import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b5f9824"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "user-popover" }
const _hoisted_3 = { class: "user-popover__top" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "user-popover__info" }
const _hoisted_6 = { class: "user-popover__level" }
const _hoisted_7 = {
  key: 0,
  class: "user-popover__expire"
}
const _hoisted_8 = { class: "user-popover__stats" }
const _hoisted_9 = { class: "stat-item" }
const _hoisted_10 = { class: "stat-value" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "今日剩余回测数", -1))
const _hoisted_12 = { class: "stat-item" }
const _hoisted_13 = { class: "stat-value" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "剩余策略保存数", -1))
const _hoisted_15 = { class: "stat-item" }
const _hoisted_16 = { class: "stat-value" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "剩余订阅数", -1))
const _hoisted_18 = { class: "stat-item" }
const _hoisted_19 = { class: "stat-value" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "解锁星级策略", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      ref: "triggerRef",
      class: "star-user-trigger",
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.togglePanel && _ctx.togglePanel(...args)), ["stop"]))
    }, [
      _createElementVNode("img", {
        class: "star-user-trigger__avatar",
        src: _ctx.avatarUrl,
        alt: "用户头像"
      }, null, 8, _hoisted_1)
    ], 512),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.visible)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            ref: "panelRef",
            class: "star-user-popover-panel",
            style: _normalizeStyle(_ctx.panelStyle),
            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("img", {
                  class: "user-popover__avatar-lg",
                  src: _ctx.avatarUrl,
                  alt: ""
                }, null, 8, _hoisted_4),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, "星级等级：" + _toDisplayString(_ctx.starLevelText), 1),
                  (_ctx.expireText)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, "有效期至" + _toDisplayString(_ctx.expireText), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.testNumText), 1),
                  _hoisted_11
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.saveNumText), 1),
                  _hoisted_14
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.subNumText), 1),
                  _hoisted_17
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.templateLockText), 1),
                  _hoisted_20
                ])
              ])
            ])
          ], 4))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}